module.exports = __webpack_public_path__ + "static/media/joeybadass-allamerikkanbadass.6892a435.jpg";